import React from 'react';
import styled from 'styled-components';
import CheckOutlined from '@ant-design/icons/lib/icons/CheckOutlined';

export const IconCheck = ({ onClick, hide = false, size, ...props }) => {
  return (
    <IconCheckWrapper onClick={onClick} $hide={hide} $size={size} {...props}>
      <CheckOutlined />
    </IconCheckWrapper>
  );
};

const IconCheckWrapper = styled.div`
  width: ${({ $size }) => ($size ? `${$size}px` : '32px')};
  min-width: ${({ $size }) => ($size ? `${$size}px` : '32px')};
  height: ${({ $size }) => ($size ? `${$size}px` : '32px')};
  visibility: ${({ $hide }) => ($hide ? 'hidden' : 'visible')};
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2cc68f;
  color: #ffffff;
  border-radius: 100%;
  font-size: 10px;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;
